(() => {
  const validateEntry = (entry) => {
    if (['title', 'role', 'nailShape', 'nailLength'].some(key => !String(entry[key] || '').trim())) return 'required';
    const images = entry.media.filter(item => item.type === 'image').length;
    return !entry.media.some(item => ['image', 'video'].includes(item.type)) || images > 9 ? 'photos' : '';
  };
  const collectProducts = (entries) => {
    const products = [];
    for (const [key, value] of entries) {
      const match = key.match(/^products\[(\d+)\]\[(\w+)\]$/);
      if (match) (products[Number(match[1])] ||= {})[match[2]] = match[2] === 'productPrice' ? Number(value) : value;
    }
    return products.filter(Boolean);
  };
  if (typeof module !== 'undefined') module.exports = { validateEntry, collectProducts };
  if (typeof window === 'undefined' || customElements.get('monthly-challenge-form')) return;
  customElements.define('monthly-challenge-form', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.media = [];
      this.config = JSON.parse(this.querySelector('[data-config]').textContent);
      this.dialog = this.querySelector('dialog');
      this.form = this.querySelector('form');
      this.form.noValidate = true;
      this.status = this.querySelector('[data-status]');
      this.initialPicker = this.querySelector('[data-community-product-picker]').cloneNode(true);
      const options = { signal: this.abort.signal };
      ['input', 'change'].forEach(name => this.form.addEventListener(name, event => {
        if (event.target.name) this.clearFieldError(event.target.name);
      }, options));
      this.closest('[data-monthly-challenge]')?.addEventListener('click', event => {
        const opener = event.target.closest('[data-monthly-entry-open]');
        if (opener) this.open(opener);
      }, options);
      this.addEventListener('click', event => {
        const opener = event.target.closest('[data-open]');
        if (opener) this.open(opener);
        if (event.target.closest('[data-close]')) this.dialog.close();
        if (event.target.closest('[data-add]')) {
          if (!this.config.loggedIn) { this.message('login'); this.querySelector('[data-login]').hidden = false; this.status.scrollIntoView({ block: 'nearest' }); }
          else if (!this.config.canSubmit) this.message('closed');
          else this.querySelector('[data-files]').click();
        }
        const remove = event.target.closest('[data-remove]');
        const move = event.target.closest('[data-move]');
        if (move && !this.busy) {
          const index = Number(move.dataset.index), target = index + Number(move.dataset.move);
          if (target >= 0 && target < this.media.length) {
            [this.media[index], this.media[target]] = [this.media[target], this.media[index]];
            this.renderMedia();
          }
        }
        const retry = event.target.closest('[data-retry-upload]');
        if (retry && !this.busy) this.uploadItem(this.media[Number(retry.dataset.retryUpload)]).catch(() => {});
        if (remove && !this.busy) {
          const index = Number(remove.dataset.remove);
          URL.revokeObjectURL(this.media[index].preview);
          this.media.splice(index, 1);
          this.renderMedia();
        }
      }, options);
      this.querySelector('[data-files]').addEventListener('change', event => {
        this.addFiles(Array.from(event.target.files));
        event.target.value = '';
      }, options);
      this.form.addEventListener('submit', event => { event.preventDefault(); this.submit(); }, options);
      this.dialog.addEventListener('close', () => {
        this.querySelectorAll('[data-media] video').forEach(video => video.pause());
        document.documentElement.style.overflow = this.previousOverflow;
        window.CommunitySelect?.closeAll();
        this.opener?.focus();
      }, options);
      this.dialog.addEventListener('cancel', event => event.preventDefault(), options);
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.abort?.abort();
      this.media?.forEach(item => URL.revokeObjectURL(item.preview));
    }
    fieldError(name, text) {
      const control = name === 'media' ? this.querySelector('[data-add]') : this.form.elements.namedItem(name);
      if (!control) return;
      let error = this.querySelector(`[data-field-error="${name}"]`);
      if (!error) {
        error = document.createElement('p'); error.className = 'monthly-entry__field-error'; error.dataset.fieldError = name;
        error.id = `${this.dialog.id}-${name}-error`; error.setAttribute('role', 'alert');
        const anchor = name === 'media' ? control.closest('.monthly-entry__field') : control.closest('.community-select') || control.closest('.monthly-entry__consent') || control;
        if (name === 'media') anchor.append(error); else anchor.after(error);
      }
      error.textContent = text; error.hidden = false;
      const visible = control.closest('.community-select')?.querySelector('.community-select__trigger') || control;
      [control, visible].forEach(node => { node.setAttribute('aria-invalid', 'true'); node.setAttribute('aria-describedby', error.id); });
    }
    clearFieldError(name) {
      const error = this.querySelector(`[data-field-error="${name}"]`);
      if (!error) return;
      error.hidden = true; error.textContent = '';
      this.querySelectorAll(`[aria-describedby="${error.id}"]`).forEach(node => { node.removeAttribute('aria-invalid'); node.removeAttribute('aria-describedby'); });
    }
    clearFieldErrors() { this.querySelectorAll('[data-field-error]').forEach(node => this.clearFieldError(node.dataset.fieldError)); }
    showFirstError() { this.querySelector('[data-field-error]:not([hidden])')?.scrollIntoView({ block: 'center', behavior: 'smooth' }); }
    message(key) {
      const text = this.config.messages[key] || this.config.messages.failed;
      if (['photos', 'fileType'].includes(key)) { this.fieldError('media', text); return; }
      this.status.textContent = text;
    }
    setActivity(activity) {
      if (this.busy) return;
      const activityChanged = this.config.activityId !== activity?.id;
      if (activityChanged) {
        this.clearFieldErrors();
        this.form.reset();
        this.media.forEach(item => URL.revokeObjectURL(item.preview)); this.media = []; this.renderMedia();
        const picker = this.querySelector('[data-community-product-picker]');
        const replacement = this.initialPicker.cloneNode(true); delete replacement.dataset.communityProductPickerReady;
        picker.replaceWith(replacement); window.CommunityProductPicker?.init(replacement);
      }
      this.activity = activity;
      Object.assign(this.config, { activityId: activity?.id, challenge: activity?.name, campaignTag: activity?.campaignTag, canSubmit: window.MonthlyChallenge.canSubmit(activity) });
      this.querySelector('[data-activity-name]').value = activity?.name || '';
      this.querySelector('[data-activity-tag]').value = activity?.campaignTag || '';
      const select = this.form.elements.role;
      const selected = activityChanged ? '' : select.value;
      const roles = activity?.roles || [];
      select.replaceChildren(...roles.map((role, index) => new Option(role, role, index === roles.length - 1, index === roles.length - 1)));
      if (roles.includes(selected)) select.value = selected;
      window.CommunitySelect?.refresh(select);
      this.querySelector('[type="submit"]').disabled = !this.config.canSubmit || !activity?.roles?.length;
      this.status.textContent = '';
      if (!this.config.canSubmit) this.message('closed');
    }
    async open(opener) {
      if (this.dialog.open || this.opening) return;
      this.opening = true;
      opener?.setAttribute('aria-busy', 'true');
      const activityId = this.config.activityId;
      try {
        if (!activityId || !this.adapter?.getActivity) throw Error(this.config.messages.unavailable);
        const activity = await this.adapter.getActivity(activityId, { signal: this.abort.signal });
        if (this.abort.signal.aborted || String(this.config.activityId) !== String(activityId)) return;
        this.setActivity(activity);
        if (!this.config.canSubmit) {
          window.publicComponents?.messageOpen({ content: this.config.messages.closed, type: 'info', duration: 4200 });
          return;
        }
        const root = this.closest('[data-monthly-challenge]');
        if (root && window.CommunityRequireLogin && !window.CommunityRequireLogin(root)) return;
        this.opener = opener;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
        window.CommunitySelect?.initAll(this);
        window.CommunityProductPicker?.initAll(this);
      } catch (error) {
        if (!this.abort.signal.aborted && String(this.config.activityId) === String(activityId)) {
          window.publicComponents?.messageOpen({ content: error.message || this.config.messages.unavailable, type: 'error', duration: 4200 });
        }
      } finally {
        this.opening = false;
        opener?.removeAttribute('aria-busy');
      }
    }
    addFiles(files) {
      if (this.busy) return;
      if (!this.config.loggedIn) { this.message('login'); this.querySelector('[data-login]').hidden = false; return; }
      if (!this.config.canSubmit) { this.message('closed'); return; }
      this.status.textContent = '';
      this.clearFieldError('media');
      for (const file of files) {
        const type = file.type.startsWith('image/') ? 'image' : file.type.startsWith('video/') ? 'video' : '';
        if (!type) { this.message('fileType'); continue; }
        if (type === 'image' && this.media.filter(item => item.type === 'image').length >= 9) { this.message('photos'); continue; }
        const item = { file, type, preview: URL.createObjectURL(file) };
        this.media.push(item);
        this.uploadItem(item).catch(() => {});
      }
      this.renderMedia();
    }
    uploadItem(item) {
      if (item.pending) return item.pending;
      if (item.url) return Promise.resolve();
      item.state = 'uploading';
      this.renderMedia();
      item.pending = (async () => {
        try {
          const result = await this.adapter.uploadMedia({ file: item.file }, { signal: this.abort.signal });
          if (!result?.url || new URL(result.url).protocol !== 'https:') throw new Error('Invalid media URL');
          item.url = result.url; item.state = 'success';
        } catch (error) { item.state = 'error'; throw error; }
        finally {
          item.pending = null;
          if (this.isConnected && this.media.includes(item)) this.renderMedia();
        }
      })();
      return item.pending;
    }
    renderMedia() {
      const list = this.querySelector('[data-media]');
      list.replaceChildren();
      let cover = false;
      this.media.forEach((item, index) => {
        const tile = document.createElement('div'); tile.className = 'monthly-entry__tile'; tile.dataset.uploadState = item.state || '';
        const preview = document.createElement(item.type === 'image' ? 'img' : 'video');
        preview.src = item.preview;
        if (item.type === 'image') preview.alt = item.file.name;
        else {
          preview.controls = false; preview.preload = 'metadata'; preview.muted = true; preview.playsInline = true; preview.setAttribute('aria-label', item.file.name);
          const play = document.createElement('button');
          play.type = 'button'; play.className = 'monthly-entry__play'; play.textContent = '▶';
          play.setAttribute('aria-label', `Play ${item.file.name}`);
          const syncPlayback = () => {
            const playing = !preview.paused && !preview.ended;
            preview.controls = playing; play.hidden = playing;
          };
          play.addEventListener('click', () => preview.play().catch(syncPlayback));
          ['play', 'pause', 'ended'].forEach(name => preview.addEventListener(name, syncPlayback));
          tile.append(play);
        }
        tile.append(preview);
        if (!cover && item.type === 'image') { const badge = document.createElement('span'); badge.textContent = this.config.messages.cover; tile.append(badge); cover = true; }
        const remove = document.createElement('button'); remove.type = 'button'; remove.dataset.remove = index;
        remove.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true" focusable="false"><path d="M2 2L8 8M8 2L2 8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/></svg>';
        remove.setAttribute('aria-label', `${this.config.messages.remove} ${item.file.name}`); tile.append(remove);
        const order = document.createElement('div'); order.className = 'monthly-entry__media-order';
        [-1, 1].forEach(direction => {
          const button = document.createElement('button'); button.type = 'button'; button.dataset.move = direction; button.dataset.index = index;
          button.textContent = direction < 0 ? '←' : '→'; button.setAttribute('aria-label', `Move ${item.file.name} ${direction < 0 ? 'earlier' : 'later'}`);
          button.disabled = index + direction < 0 || index + direction >= this.media.length; order.append(button);
        });
        tile.append(order);
        if (item.state === 'error') {
          const retry = document.createElement('button'); retry.type = 'button'; retry.dataset.retryUpload = index; retry.textContent = 'Retry upload'; tile.append(retry);
        }
        list.append(tile);
      });
      const count = this.media.filter(item => item.type === 'image').length, left = 9 - count;
      const videos = this.media.length - count;
      this.querySelector('[data-count]').innerHTML = `${count}/9 added · <em>${left} left</em>${videos ? ` · ${videos} video${videos > 1 ? 's' : ''}` : ''}`;
      this.querySelector('[data-media-left]').textContent = left ? `${left} left` : 'Video only';
      this.querySelector('[data-files]').accept = left ? 'image/*,video/*' : 'video/*';
      const status = this.querySelector('[data-upload-status]');
      status.textContent = this.media.some(item => item.state === 'uploading') ? 'Uploading media…' : this.media.some(item => item.state === 'error') ? 'Upload failed. Please retry or remove the file.' : this.media.length ? 'Media uploaded.' : '';
      status.classList.toggle('is-error', this.media.some(item => item.state === 'error'));
    }
    async submit() {
      if (this.busy) return;
      this.clearFieldErrors(); this.status.textContent = '';
      if (!this.config.loggedIn) { this.message('login'); this.querySelector('[data-login]').hidden = false; return; }
      if (!window.MonthlyChallenge.canSubmit(this.activity)) { this.message('closed'); return; }
      const data = new FormData(this.form);
      const entry = {
        activityId: this.config.activityId, challenge: this.config.challenge, campaignTag: this.config.campaignTag,
        title: String(data.get('title') || '').trim(), content: String(data.get('content') || '').trim(),
        role: data.get('role'), nailShape: data.get('nailShape'), nailLength: data.get('nailLength'), skinTone: data.get('skinTone'),
        contentLicense: data.has('contentLicense'), userAuthorization: data.has('userAuthorization'),
        products: collectProducts(data), media: this.media
      };
      const labels = { title: 'a title', role: 'a role', nailShape: 'a nail shape', nailLength: 'a nail length' };
      for (const [name, label] of Object.entries(labels)) {
        if (!String(entry[name] || '').trim()) this.fieldError(name, `Please ${name === 'title' ? 'enter' : 'choose'} ${label}.`);
      }
      for (const name of ['title', 'content']) {
        const control = this.form.elements.namedItem(name);
        if (entry[name].length > control.maxLength) this.fieldError(name, `Please use no more than ${control.maxLength} characters.`);
      }
      if (!entry.contentLicense) this.fieldError('contentLicense', this.config.messages.ownership);
      if (!entry.media.length || entry.media.filter(item => item.type === 'image').length > 9) this.message('photos');
      if (this.querySelector('[data-field-error]:not([hidden])')) { this.showFirstError(); return; }
      const adapter = this.adapter;
      if (!entry.activityId || !adapter?.uploadMedia || !adapter?.createEntry) { this.message('unavailable'); return; }
      this.busy = true;
      const submit = this.form.querySelector('[type="submit"]');
      this.form.querySelector('fieldset').disabled = true;
      submit.setAttribute('aria-busy', 'true');
      try {
        const media = [];
        for (const item of this.media) {
          await this.uploadItem(item);
          media.push({ type: item.type, url: item.url });
        }
        const result = await adapter.createEntry({ ...entry, media }, { signal: this.abort.signal });
        if (!result?.id || result.published !== true) throw new Error('Missing entry confirmation');
        this.message('success');
        this.media.forEach(item => URL.revokeObjectURL(item.preview)); this.media = []; this.renderMedia();
        this.form.reset();
        // Replace the picker to clear its private selection Map, including off-screen search selections.
        const picker = this.querySelector('[data-community-product-picker]');
        const replacement = this.initialPicker.cloneNode(true); delete replacement.dataset.communityProductPickerReady;
        replacement.querySelector('[data-community-product-fields]').replaceChildren();
        replacement.querySelectorAll('input[type=checkbox]').forEach(input => { input.checked = false; });
        picker.replaceWith(replacement); window.CommunityProductPicker?.init(replacement);
        this.querySelectorAll('select').forEach(select => window.CommunitySelect?.sync(select));
        this.dispatchEvent(new CustomEvent('monthly-challenge:created', { bubbles: true, detail: result }));
      } catch (error) {
        if (error.name !== 'AbortError') {
          this.status.textContent = '';
          if (this.media.some(item => item.state === 'error') || /\b(photo|photos|video|videos|media|upload|uploads|images)\b/i.test(error.message || '')) {
            this.fieldError('media', error.message || this.config.messages.failed); this.showFirstError();
          } else this.status.textContent = error.message || this.config.messages.failed;
        }
      }
      finally { this.busy = false; this.form.querySelector('fieldset').disabled = false; submit.removeAttribute('aria-busy'); }
    }
  });
})();
